// extracted by mini-css-extract-plugin
export default {"container":"style_container__VjbOo","card":"style_card__ZZC0U","row":"style_row__l5SnZ","btnsRow":"style_btnsRow__jheA5"};